import { render, staticRenderFns } from "./DoctorSchedulePage.vue?vue&type=template&id=3daf165e&scoped=true"
import script from "./DoctorSchedulePage.vue?vue&type=script&lang=js"
export * from "./DoctorSchedulePage.vue?vue&type=script&lang=js"
import style0 from "./DoctorSchedulePage.vue?vue&type=style&index=0&id=3daf165e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3daf165e",
  null
  
)

export default component.exports